/**
 * @author Akash Mishra <akashmishra@eurofins.com>
 */
import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { RequirementDialogReq } from 'src/app/core/interfaces/test-code';

@Component({
    selector: 'app-order-specimen-dialog',
    templateUrl: './order-specimen-dialog.component.html',
    styleUrls: ['./order-specimen-dialog.component.scss'],
    standalone: false
})
// tslint:disable-next-line: component-class-suffix
export class OrderSpecimenDialogomponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public data: RequirementDialogReq,
              public dialogRef: MatDialogRef<OrderSpecimenDialogomponent>) { }

  ngOnInit(): void {
    // can perform any logical implemention here if required
  }

  closeDialog() {
    this.dialogRef.close(false);
  }
}
